/**
 * LocalStorage key constants
 * Centralized storage keys for consistent access across the application
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
  ROLES: 'roles',
  PERMISSIONS: 'permissions',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
